export default __webpack_public_path__ + "static/path-dark-4b653f7974ed175cdddcd36d6072a5ec.png";